import React from "react";
import { Link, useLocation } from "react-router-dom";
import { AiOutlineHome, AiOutlineSearch, AiOutlineShopping } from "react-icons/ai";
import { CgProfile } from "react-icons/cg";
import { useSelector } from "react-redux";

const linkClass = (active) =>
  `flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-semibold transition ${
    active ? "text-[#38513b]" : "text-slate-500"
  }`;

/**
 * Vinted-style bottom navigation (mobile only).
 */
export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const { isAuthenticated } = useSelector((state) => state.user);

  const isHome = pathname === "/";
  const isSearch = pathname === "/search" || pathname.startsWith("/search/");
  const isShop =
    pathname === "/products" ||
    pathname.startsWith("/products/") ||
    pathname.startsWith("/product/");
  const isProfile = pathname.startsWith("/profile");

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-slate-200 bg-white pb-[max(0.35rem,env(safe-area-inset-bottom))] pt-1 shadow-[0_-4px_16px_rgba(15,23,42,0.08)] 800px:hidden"
      aria-label="Mobile navigation"
    >
      <div className="mx-auto flex max-w-lg items-stretch">
        <Link to="/" className={linkClass(isHome)} aria-current={isHome ? "page" : undefined}>
          <AiOutlineHome size={22} />
          Home
        </Link>
        <Link
          to="/search"
          className={linkClass(isSearch)}
          aria-current={isSearch ? "page" : undefined}
        >
          <AiOutlineSearch size={22} />
          Search
        </Link>
        <Link
          to="/products"
          className={linkClass(isShop && !isSearch)}
          aria-current={isShop && !isSearch ? "page" : undefined}
        >
          <AiOutlineShopping size={22} />
          Products
        </Link>
        <Link
          to={isAuthenticated ? "/profile" : "/login"}
          className={linkClass(isProfile)}
          aria-current={isProfile ? "page" : undefined}
        >
          <CgProfile size={22} />
          {isAuthenticated ? "Profile" : "Sign in"}
        </Link>
      </div>
    </nav>
  );
}

/** Paths where the bottom bar should not appear (auth, checkout, admin login). */
export function shouldShowMobileBottomNav(pathname) {
  if (!pathname) return false;
  const hiddenPrefixes = [
    "/login",
    "/sign-up",
    "/forgot-password",
    "/reset-password",
    "/activation",
    "/seller/activation",
    "/checkout",
    "/payment",
    "/shop-login",
    "/create-shop",
    "/admin/login",
  ];
  if (hiddenPrefixes.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    return false;
  }
  return true;
}
